import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { Login } from 'src/app/_models/login';
import { UserInfos } from 'src/app/_models/user.infos';
import { HttpHeaderJson } from 'src/app/_constants/http.header.json';
import { User } from 'src/app/_models/user';
import { UserCad } from 'src/app/_models/user.cad';
import { UserEdicao } from 'src/app/_models/user.edicao';
import { UserEmail } from 'src/app/_models/user.email';
import { UserPass } from 'src/app/_models/user.pass';
import { ResetPassord } from 'src/app/_models/resetPassword';


@Injectable({ providedIn: 'root' })
export class AccontService {

  constructor(private httpClient: HttpClient) { }

  login(login: Login): Observable<UserInfos> {
    return this.httpClient.post<UserInfos>(`${environment.apiUrl}/account/login`, login, HttpHeaderJson)
  }
  
  getAllUsersEdicao(): Observable<UserEdicao[]> {
    return this.httpClient.get<UserEdicao[]>(`${environment.apiUrl}/account/obter-todos-usuarios-edicao`);
  }

  registrarLoginAdmin(userCad: UserCad): Observable<UserCad> {
    return this.httpClient.post<UserCad>(`${environment.apiUrl}/account/registar-login-admin`, userCad);
  }

  editarUsuario(userCad: UserEdicao): Observable<UserEdicao> {
    return this.httpClient.put<UserEdicao>(`${environment.apiUrl}/account/editar-usuario`, userCad);
  }

  redefinirSenhaInternamente(userpass: UserPass): Observable<UserPass> {
    return this.httpClient.post<UserPass>(`${environment.apiUrl}/account/reset-password-internal`, userpass);
  }

  bloquearUsuario(email: string): Observable<UserEmail> {
    let userMail: UserEmail = { email: email }
    return this.httpClient.post<any>(`${environment.apiUrl}/account/lock-user-account`, userMail);
  }

  desBloquearUsuario(email: string): Observable<UserEmail> {
    let userMail: UserEmail = { email: email }
    return this.httpClient.post<any>(`${environment.apiUrl}/account/unlock-user-account`, userMail);
  }

  excluirUsuario(usuarioId: string): Observable<Response> {
    return this.httpClient.delete<Response>(`${environment.apiUrl}/account/remover-usuario/` + usuarioId, HttpHeaderJson);
  }

  forgotPassword(email: string): Observable<Response> {
    let userMail = {
      email: email
    };
    return this.httpClient.post<any>(`${environment.apiUrl}/account/forgot-password`, userMail);
  }

  resetPassword(resetpass: ResetPassord): Observable<Response>{
    return this.httpClient.post<any>(`${environment.apiUrl}/account/reset-password`, resetpass);
  }

}